import { InputAdornment, TextField, TextFieldProps } from '@mui/material';
import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import EyeOffFillIcon from 'remixicon-react/EyeOffFillIcon';
import EyeFillIcon from 'remixicon-react/EyeFillIcon';

type PasswordInputPropTypes = TextFieldProps;

const PasswordInput: React.FC<PasswordInputPropTypes> = ({ ...rest }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextField
      {...rest}
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={() => setShowPassword((prev) => !prev)} tabIndex={-1}>
              {showPassword ? <EyeOffFillIcon /> : <EyeFillIcon />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default PasswordInput;
